/**
 * Список образовательных организаций для карты
 */
import { InstitutionMapPoint } from '@n3/ng-api-common';
import { BaseModel } from '@n3/ng-api-base-kit';

export class InstitutionMapList extends BaseModel {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/
    public items: InstitutionMapPoint[]; /**/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super();

        this.items = [];
        if (json.items) {
          for (const i in json.items) {
            if ( json.items.hasOwnProperty( i ) ) {
                this.items.push(new InstitutionMapPoint(json.items[i]));
            }
          }
        }
        this._isEmpty = this.isEmpty(this);
    }
}
